import axiosInstance, { axiosInstanceSecured } from "./axiosInstance";
import API_ENDPOINTS from "../config/apiEndpoints";


export const getManagerExpertStoreList = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_ENDPOINTS.STORES.DROPDOWN}`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("Error adding data:", error);
    throw error;
  }
};
export const getServiceTypes = async (data) => {
  try {
    const response = await axiosInstance.post(
      API_ENDPOINTS.SERVICETYPES.SERVICE_TYPES,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("Error adding data:", error);
    throw error;
  }
};

export const getCurrentUser = async () => {
  try {
    const response = await axiosInstanceSecured.get(
      API_ENDPOINTS.ACCOUNT.CURRENT_USER,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching current user:", error);
    throw error;
  }
};
export const encryptObj = (obj) => {
  return JSON.stringify(obj);
};

export const decryptObj = (obj) => {
  return JSON.parse(obj);
};
